export default __webpack_public_path__ + "static/media/btn_remove.30776092.svg";